import TextSymbol from "@arcgis/core/symbols/TextSymbol.js";

export default function getTextSymbol({
  markupText,
  markupFontColor,
  markupFontFamily,
  markupFontSize,
  markupFontStyle,
  markupFontWeight,
}) {
  const textSymbol = new TextSymbol({
    color: markupFontColor,
    haloColor: "black",
    haloSize: "0px",
    text: markupText,
    xoffset: 0,
    yoffset: 0,
    font: {
      size: markupFontSize,
      family: markupFontFamily,
      weight: markupFontWeight,
      style: markupFontStyle,
    },
  });
  return textSymbol;
}
